var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.82994 5.28995L2.58994 1.04995C2.40218 0.860636 2.14658 0.75415 1.87994 0.75415C1.61331 0.75415 1.35771 0.860636 1.16994 1.04995C0.782219 1.43999 0.782219 2.06991 1.16994 2.45995L4.70994 5.99995L1.16994 9.53995C0.782219 9.92999 0.782219 10.5599 1.16994 10.9499C1.35866 11.1371 1.61414 11.2415 1.87994 11.2399C2.14575 11.2415 2.40122 11.1371 2.58994 10.9499L6.82994 6.70995C7.01926 6.52218 7.12574 6.26659 7.12574 5.99995C7.12574 5.73331 7.01926 5.47772 6.82994 5.28995Z","fill":"white"}));
}

ArrowRight.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
